<h1 class="text-lg text-color-secondary font-bold mb-3 mt-3 titulo">
  {{ texto | uppercase }}
</h1>
